export const listSVGIcon04 = {
  cccd: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 5.37354H17.5C18.1904 5.37354 18.75 5.93325 18.75 6.62354V15.3735C18.75 16.0638 18.1904 16.6235 17.5 16.6235H2.5C1.80964 16.6235 1.25 16.0638 1.25 15.3735V6.62354C1.25 5.93325 1.80964 5.37354 2.5 5.37354Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 10.9985C7.32107 10.9985 8.1875 10.1321 8.1875 9.06104C8.1875 7.98997 7.32107 7.12354 6.25 7.12354C5.17893 7.12354 4.3125 7.98997 4.3125 9.06104C4.3125 10.1321 5.17893 10.9985 6.25 10.9985Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 8.12354H15.625"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 10.9985H14.375"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  cccd_1: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 5.37354H17.5C18.1904 5.37354 18.75 5.93325 18.75 6.62354V15.3735C18.75 16.0638 18.1904 16.6235 17.5 16.6235H2.5C1.80964 16.6235 1.25 16.0638 1.25 15.3735V6.62354C1.25 5.93325 1.80964 5.37354 2.5 5.37354Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 10.9985C7.32107 10.9985 8.1875 10.1321 8.1875 9.06104C8.1875 7.98997 7.32107 7.12354 6.25 7.12354C5.17893 7.12354 4.3125 7.98997 4.3125 9.06104C4.3125 10.1321 5.17893 10.9985 6.25 10.9985Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 8.12354H15.625"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 10.9985H14.375"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 13.8735H15.625"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}
